
/* Open external links in new tab */
var all_links = document.querySelectorAll('a');
for (var i = 0; i < all_links.length; i++){
       var a = all_links[i];
       if(a.hostname != location.hostname) {
               a.rel = 'noopener';
               a.target = '_blank';
       }
}

/* Header Sticky fix */
  document.addEventListener("scroll", function() {
    const header = document.querySelector("header");
    // Use a breakpoint of 768px to differentiate desktop from mobile (adjust if needed)
    const threshold = (window.innerWidth >= 768) ? 140 : 90;
    if (window.scrollY <= threshold) {
      header.style.visibility = "visible";
    }
  });

/* Promo Scroll + Arrows */
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('offerScrollContainer');
  if (!container) return;

  const prevBtn = document.querySelector('[data-offers-arrow="prev"]');
  const nextBtn = document.querySelector('[data-offers-arrow="next"]');

  let currentIndex = 0;
  let interval = null;
  const AUTOPLAY_MS = 5000;

  const getBlocks = () => Array.from(container.children).filter(Boolean);

  function scrollToIndex(index, behavior = 'smooth') {
    const blocks = getBlocks();
    if (!blocks.length) return;

    // wrap index
    currentIndex = (index + blocks.length) % blocks.length;

    container.scrollTo({
      left: container.clientWidth * currentIndex,
      behavior
    });
  }

  function scrollToNext() {
    scrollToIndex(currentIndex + 1);
  }

  function scrollToPrev() {
    scrollToIndex(currentIndex - 1);
  }

  function startAutoScroll() {
    stopAutoScroll(); // avoid duplicates
    const blocks = getBlocks();
    if (blocks.length <= 1) return; // no need to autoplay
    interval = setInterval(scrollToNext, AUTOPLAY_MS);
  }

  function stopAutoScroll() {
    if (interval) clearInterval(interval);
    interval = null;
  }

  function restartAutoScroll() {
    startAutoScroll();
  }

  // Click arrows
  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      stopAutoScroll();
      scrollToPrev();
      restartAutoScroll();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      stopAutoScroll();
      scrollToNext();
      restartAutoScroll();
    });
  }

  // Pause on hover (desktop)
  container.addEventListener('mouseenter', stopAutoScroll);
  container.addEventListener('mouseleave', startAutoScroll);

  // Track user swipe/scroll to keep index in sync
  container.addEventListener('scroll', () => {
    const width = container.clientWidth || 1;
    currentIndex = Math.round(container.scrollLeft / width);
  }, { passive: true });

  // Keep index correct if resized (e.g. orientation change)
  window.addEventListener('resize', () => {
    // jump to same index without animation to avoid weird mid-slide positions
    scrollToIndex(currentIndex, 'auto');
  });

  startAutoScroll();
});

/* UC Dynamic Content Drawer (uses Impact's built-in x-drawer) */
(function() {
  function ucOpenProductAccordions(container) {
    const descriptionAccordion = container.querySelector(
      '.product-info__block-item[data-block-type="collapsible-text"] details'
    );
    if (!descriptionAccordion) return;
    descriptionAccordion.open = true;
    descriptionAccordion.setAttribute('aria-expanded', 'true');
    const content = descriptionAccordion.querySelector('.accordion__content');
    if (content) {
      content.style.opacity = '1';
      content.style.transform = 'none';
    }
  }

  function ucOpenDrawer(event, trigger) {
    event.preventDefault();
    const drawer = document.getElementById('uc-drawer');
    const titleEl = document.getElementById('uc-drawer-title');
    const contentEl = document.getElementById('uc-drawer-content');
    let url = trigger.getAttribute('data-url');

    // Handle hash anchors
    let hash = null;
    if (url.includes('#')) {
      const parts = url.split('#');
      url = parts[0];
      hash = '#' + parts[1];
    }

    // Show loading state and open drawer via x-drawer API
    contentEl.innerHTML = 'Loading content...';
    titleEl.textContent = 'Loading...';
    drawer.show();

    // Fetch and render content
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const mainContent = doc.querySelector('#main');

        // Update drawer title
        let title = 'Drawer';
        if (trigger.getAttribute('data-url').includes('/products/')) {
          const productTitle = doc.querySelector('.product-info__title');
          if (productTitle) title = productTitle.textContent.trim();
        } else {
          const pageTitle = doc.querySelector('title');
          if (pageTitle) title = pageTitle.textContent.trim();
        }
        titleEl.textContent = title;

        // Remove unwanted elements
        if (mainContent) {
          mainContent.querySelectorAll('.shopify-section-group-footer-group').forEach(el => el.remove());
          mainContent.querySelectorAll('h1').forEach(el => el.remove());

          if (trigger.getAttribute('data-url').includes('/products/')) {
            mainContent.querySelectorAll('.h2').forEach(el => el.remove());
            mainContent.querySelectorAll('.breadcrumb').forEach(el => el.remove());
            mainContent.querySelectorAll('.shopify-section--rich-text').forEach(el => el.remove());
            mainContent.querySelectorAll('.jdgm-review-widget').forEach(el => el.remove());
            mainContent.querySelectorAll('.shopify-section--product-recommendations').forEach(el => el.remove());
            mainContent.querySelectorAll('.shopify-section--recently-viewed-products').forEach(el => el.remove());
            mainContent.querySelectorAll('.product-info__payment-terms').forEach(el => el.remove());
          }

          contentEl.innerHTML = mainContent.innerHTML;

          // Re-execute injected <script> tags so anything inline can run.
          contentEl.querySelectorAll('script').forEach(oldScript => {
            const s = document.createElement('script');
            for (const attr of oldScript.attributes) s.setAttribute(attr.name, attr.value);
            s.text = oldScript.textContent;
            oldScript.parentNode.replaceChild(s, oldScript);
          });

          // ─── Quick-view treatment (eye-button on Ready Made cards only) ───
          // The trigger sets data-quickview="ready-made". We strip everything
          // except the first .shopify-section (the main-product section) so the
          // drawer shows just the product info — images, title, price, variant
          // picker, add-to-cart, description. No related products, no reviews.
          // Drawer uses from other triggers (no data-quickview) are unaffected.
          if (trigger.getAttribute('data-quickview') === 'ready-made') {
            const sections = contentEl.querySelectorAll('.shopify-section');
            sections.forEach((sec, i) => { if (i > 0) sec.remove(); });

            // Scope class so all quickview-specific CSS only targets here.
            contentEl.classList.add('uc-drawer--quickview');
            drawer.classList.add('uc-drawer--quickview-active');

            // Move buy_buttons block to sit directly after the price block
            const priceBlock = contentEl.querySelector('.product-info__block-item[data-block-type="price"]');
            const buyButtonsBlock = contentEl.querySelector('.product-info__block-item[data-block-type="buy-buttons"], .product-info__block-item[data-block-type="buy_buttons"]');
            if (priceBlock && buyButtonsBlock && priceBlock !== buyButtonsBlock) {
              priceBlock.insertAdjacentElement('afterend', buyButtonsBlock);
            }

            // Strip blocks that render invisibly but still take vertical space:
            //   - variant-picker (Ready Mades have 1 variant)
            //   - LPO app block (empty placeholder Cloudlift can't bind to)
            //   - collapsible-text accordions whose body is empty (e.g. Description
            //     when product.description is blank)
            //   - any block whose visible text+media content is empty
            contentEl.querySelectorAll('.product-info__block-item').forEach(block => {
              const type = block.getAttribute('data-block-type');
              if (type === 'variant-picker' || type === 'variant_picker') {
                block.remove();
                return;
              }
              // Empty LPO placeholder
              if (block.querySelector('[data-live-options]')) {
                block.remove();
                return;
              }
              // Collapsible-text with empty body (Description when product.description is blank)
              if (type === 'collapsible-text' || type === 'collapsible_text') {
                const body = block.querySelector('.accordion__content');
                if (body && body.textContent.trim().length === 0) {
                  block.remove();
                  return;
                }
              }
              // Block has no visible text and no media — pure empty spacer
              const hasText = block.textContent.trim().length > 0;
              const hasMedia = block.querySelector('img, svg, video, iframe, picture, hr, input, button');
              if (!hasText && !hasMedia) {
                block.remove();
              }
            });
          }

          // Auto-open product description accordion (but NOT for Ready Made
          // quick views — user wants those to start collapsed).
          if (trigger.getAttribute('data-url').includes('/products/') &&
              trigger.getAttribute('data-quickview') !== 'ready-made') {
            setTimeout(() => ucOpenProductAccordions(contentEl), 50);
          }

          // Scroll to hash anchor if present
          if (hash) {
            setTimeout(() => {
              const targetElement = contentEl.querySelector(hash);
              if (targetElement) targetElement.scrollIntoView({ behavior: 'smooth' });
            }, 100);
          }
        } else {
          contentEl.innerHTML = 'Failed to load content. Please try again.';
        }
      })
      .catch(() => {
        contentEl.innerHTML = 'Failed to load content. Please try again.';
      });
  }

  function ucCloseDrawer() {
    document.getElementById('uc-drawer').hide();
  }

  // Auto-close drawer on add-to-cart button click
  document.addEventListener('click', (event) => {
    if (event.target.closest('button.button.button--xl[is="custom-button"]')) {
      setTimeout(() => ucCloseDrawer(), 1500);
    }
  });

  window.ucOpenDrawer = ucOpenDrawer;
  window.ucCloseDrawer = ucCloseDrawer;
})();

// Basic Countdown Timer

document.addEventListener("DOMContentLoaded", () => {
  const timers = document.querySelectorAll(".simple-countdown[data-end-at]");
  if (!timers.length) return;

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function tick() {
    const now = Date.now();

    timers.forEach((el) => {
      const endRaw = el.getAttribute("data-end-at");
      const end = new Date(endRaw).getTime();

      if (!end || Number.isNaN(end)) return;

      const diff = end - now;

            // ✅ Hide when finished
      if (diff <= 0) {
        el.style.display = "none";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      el.innerHTML = `
  ${pad(days)} <span class="countdown-label">D</span>
  ${pad(hours)} <span class="countdown-label">H</span>
  ${pad(minutes)} <span class="countdown-label">M</span>
  ${pad(seconds)} <span class="countdown-label">S</span>
`;
    });
  }

  tick();
  setInterval(tick, 1000);
});

